import Map from 'ol/Map';
import VectorSource from 'ol/source/Vector';
import Polygon from 'ol/geom/Polygon';
import { buffer as OlBuffer } from 'ol/extent';
import Feature from 'ol/Feature';
import { buildServiceAreaGeometry, isFeatureWithinServiceArea } from '../../map/serviceAreaUtils';

export const isValidAoi = (aoiSource, myCoverage) => {
    if (aoiSource?.getFeatures()?.length <= 0) {
        return false;
    }

    if (myCoverage?.serviceAreas?.length && aoiSource) {
        const serviceAreaGeometry = buildServiceAreaGeometry(myCoverage.serviceAreas);
        const [feature] = aoiSource.getFeatures();
        return isFeatureWithinServiceArea(feature, serviceAreaGeometry);
    }
    // if service area failed to fetch, assume valid to not block drawing/saving bookmarks
    // users can't submit to backend if they are outside the service area, so this is a safe assumption
    return true;
};

export const formatArea = (geometry) => {
    const areaInM2 = geometry?.getArea?.() ?? 0;

    let value;
    let unit;

    if (areaInM2 > 10000) {
        value = Math.round((areaInM2 / 1000000) * 100) / 100;
        unit = 'km²';
    } else {
        value = Math.round(areaInM2 * 100) / 100;
        unit = 'm²';
    }

    return `${value} ${unit}`;
};

export const getCenter = (aoi) => {
    const map = new Map();
    const aoiSource = new VectorSource({ features: [aoi] });
    map.getView().fit(aoiSource.getExtent(), { padding: [50, 50, 50, 50] });
    return map.getView().getCenter();
};

export const bufferedPoint = (point, radius = 50) => {
    const extent = [...point, ...point];
    const bufferedExtent = new OlBuffer(extent, radius);
    const bufferPolygon = new Polygon([[
        [bufferedExtent[0], bufferedExtent[1]],
        [bufferedExtent[0], bufferedExtent[3]],
        [bufferedExtent[2], bufferedExtent[3]],
        [bufferedExtent[2], bufferedExtent[1]],
        [bufferedExtent[0], bufferedExtent[1]]
    ]]);
    return new Feature(bufferPolygon);
};

export default formatArea;
